import { Typography } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers-pro";
import { FC } from "react";

const CustomCalendarHeader: FC<PickersCalendarHeaderProps> = ({
  currentMonth,
}) => (
  <Typography variant="body1" sx={{ textAlign: "center", mt: "1rem" }}>
    {currentMonth.toLocaleString("default", { month: "long" })}
  </Typography>
);

export default CustomCalendarHeader;
